// redux/actions/meals.js

import axios from "axios";
import { BaseUrl } from "../../server";


/* =====================================================
   GET ALL MEALS
===================================================== */

export const getAllMeals =
  (
    page = 0,
    limit = 10,
    categoryId,
    titleAr,
    titleEn,
    sortOrder
  ) =>
  async (dispatch) => {
    try {
      dispatch({
        type: "get_all_meals_request",
      });

      const params = {
        page,
        limit,
      };


      if (categoryId) {
        params.categoryId =
          categoryId;
      }

      if (titleAr) {
        params.titleAr =
          titleAr;
      }

      if (titleEn) {
        params.titleEn =
          titleEn;
      }

      if (sortOrder) {
        params.sortOrder =
          sortOrder;
      }


      const { data } =
        await axios.get(
          `${BaseUrl}/meals`,
          {
            params,
          }
        );


      dispatch({
        type: "get_all_meals_success",

        payload: {
          meals:
            data.meals || [],

          pagination:
            data.pagination,

          totalmeals:
            data.totalMeals || 0,
        },
      });
    } catch (error) {
      dispatch({
        type: "get_all_meals_error",

        payload:
          error.response?.data
            ?.message ||
          error.message ||
          "حدث خطأ أثناء جلب الوجبات",
      });
    }
  };


/* =====================================================
   FILTER MEALS
   Admin Filter
===================================================== */

export const getFilteredMeals =
  (
    page = 0,
    limit = 10,
    categoryId,
    titleAr,
    titleEn,
    price
  ) =>
  async (dispatch) => {
    try {
      dispatch({
        type: "get_Fillter_meals_request",
      });


      const params = {
        page,
        limit,
      };


      if (categoryId) {
        params.categoryId =
          categoryId;
      }

      if (titleAr) {
        params.titleAr =
          titleAr;
      }

      if (titleEn) {
        params.titleEn =
          titleEn;
      }

      if (
        price !== undefined &&
        price !== ""
      ) {
        params.price =
          price;
      }


      const { data } =
        await axios.get(
          `${BaseUrl}/meals/filter`,
          {
            params,

            withCredentials:
              true,
          }
        );


      dispatch({
        type: "get_Fillter_meals_success",

        payload: {
          meals:
            data.meals || [],

          pagination:
            data.pagination,

          totalmeals:
            data.totalMeals || 0,
        },
      });
    } catch (error) {
      dispatch({
        type: "get_Fillter_meals_error",

        payload:
          error.response?.data
            ?.message ||
          error.message ||
          "حدث خطأ أثناء تصفية الوجبات",
      });
    }
  };


/*
 * دعم مؤقت للكود القديم.
 *
 * إذا كان لديك Components ما زالت تستورد:
 *
 * getFillterMeals
 *
 * فلن تتعطل.
 *
 * لاحقًا يمكنك تغيير جميع Imports إلى:
 *
 * getFilteredMeals
 */

export const getFillterMeals =
  getFilteredMeals;


/* =====================================================
   GET MEAL BY ID
===================================================== */

export const getMeal =
  (id) =>
  async (dispatch) => {
    try {
      dispatch({
        type: "get_meal_request",
      });


      const { data } =
        await axios.get(
          `${BaseUrl}/meals/${id}`
        );


      dispatch({
        type: "get_meal_success",

        payload:
          data.meal,
      });
    } catch (error) {
      dispatch({
        type: "get_meal_error",

        payload:
          error.response?.data
            ?.message ||
          error.message ||
          "حدث خطأ أثناء جلب الوجبة",
      });
    }
  };


/* =====================================================
   CREATE MEAL
===================================================== */

export const createMeal =
  (newForm) =>
  async (dispatch) => {
    try {
      dispatch({
        type: "create_meal_request",
      });


      const config = {
        headers: {
          "Content-Type":
            "multipart/form-data",
        },

        withCredentials: true,
      };


      const { data } =
        await axios.post(
          `${BaseUrl}/meals/create`,

          newForm,

          config
        );


      dispatch({
        type: "create_meal_success",

        payload:
          data.meal,
      });


      return data.meal;
    } catch (error) {
      dispatch({
        type: "create_meal_error",

        payload:
          error.response?.data
            ?.message ||
          error.message ||
          "حدث خطأ أثناء إنشاء الوجبة",
      });

      throw error;
    }
  };


/* =====================================================
   FILTER MEALS WITH SORT
   Public Enhanced Filter
===================================================== */

export const getFilteredMealsWithSort =
  (
    page = 0,
    limit = 12,
    filters = {}
  ) =>
  async (dispatch) => {
    try {
      dispatch({
        type: "get_FillterWithSort_meals_request",
      });


      const params = {
        page,
        limit,

        categoryId:
          filters.categoryId ||
          undefined,

        /*
         * Controller الجديد يدعم search مباشرة.
         * لذلك لا حاجة لإرسال نفس القيمة
         * في titleAr و titleEn.
         */

        search:
          filters.search ||
          undefined,

        priceMin:
          filters.priceMin !==
            undefined &&
          filters.priceMin !== ""
            ? filters.priceMin
            : undefined,

        priceMax:
          filters.priceMax !==
            undefined &&
          filters.priceMax !== ""
            ? filters.priceMax
            : undefined,

        sortBy:
          filters.sortBy ||
          "default",
      };


      const { data } =
        await axios.get(
          `${BaseUrl}/meals/filter-enhanced`,
          {
            params,
          }
        );


      dispatch({
        type: "get_FillterWithSort_meals_success",

        payload: {
          meals:
            data.meals || [],

          pagination:
            data.pagination,

          totalmeals:
            data.totalMeals || 0,
        },
      });
    } catch (error) {
      dispatch({
        type: "get_FillterWithSort_meals_error",

        payload:
          error.response?.data
            ?.message ||
          error.message ||
          "حدث خطأ أثناء تصفية الوجبات",
      });
    }
  };


/* =====================================================
   UPDATE MEAL
===================================================== */

export const updateMeal =
  (
    id,
    updatedForm
  ) =>
  async (dispatch) => {
    try {
      dispatch({
        type: "update_meal_request",
      });


      const config = {
        headers: {
          "Content-Type":
            "multipart/form-data",
        },

        withCredentials: true,
      };


      const { data } =
        await axios.put(
          `${BaseUrl}/meals/${id}`,

          updatedForm,

          config
        );


      dispatch({
        type: "update_meal_success",

        payload:
          data.meal,
      });


      return data.meal;
    } catch (error) {
      dispatch({
        type: "update_meal_error",

        payload:
          error.response?.data
            ?.message ||
          error.message ||
          "حدث خطأ أثناء تحديث الوجبة",
      });

      throw error;
    }
  };


/* =====================================================
   DELETE MEAL
===================================================== */

export const deleteMeal =
  (id) =>
  async (dispatch) => {
    try {
      dispatch({
        type: "delete_meal_request",
      });


      const { data } =
        await axios.delete(
          `${BaseUrl}/meals/${id}`,

          {
            /*
             * مهم لأن Route الحذف
             * يستخدم isAuth.
             */

            withCredentials:
              true,
          }
        );


      dispatch({
        type: "delete_meal_success",

        payload: {
          id,

          message:
            data.message,
        },
      });


      return data;
    } catch (error) {
      dispatch({
        type: "delete_meal_error",

        payload:
          error.response?.data
            ?.message ||
          error.message ||
          "حدث خطأ أثناء حذف الوجبة",
      });

      throw error;
    }
  };


/* =====================================================
   LIKE MEAL
===================================================== */

export const likeMeal =
  (id) =>
  async (dispatch) => {
    try {
      const { data } =
        await axios.get(
          `${BaseUrl}/meals/like/${id}`
        );


      return {
        success:
          data.success,

        likes:
          data.likes,
      };
    } catch (error) {
      throw error;
    }
  };


/* =====================================================
   CLEAR CURRENT MEAL
===================================================== */

export const ClearMeal =
  () =>
  (dispatch) => {
    dispatch({
      type: "clear_meal",
    });
  };